module.exports = __webpack_public_path__ + "assets/36a181fdd1344173b2df0161e61c3752.mp4";